import styled, { css } from "styled-components";

export const StyledActivation = styled.div(
    () => css`
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        text-align: center;
        font-size: 2rem;
        font-weight: bold;
        color: #fff;
        text-shadow: 0 0 10px #000;
        letter-spacing: 2px;
        line-height: 1.5;
    `
);
